// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4e9d77b0","239":"f576f60c","732":"a3f45f44"}[chunkId] + ".chunk.js";
};